module.exports = __webpack_public_path__ + "assets/pride-logo-c1c01f.svg";